<div
  class="flex flex-col items-center justify-between md:h-[544px] md:px-10 xl:w-[1300px]"
>
  <div
    class="flex max-w-[500px] flex-1 flex-col justify-center text-center md:gap-10"
  >
    <div class="flex flex-col gap-4">
      <h2 class="text-primary-900">
        {{ "calculator.basicInfo" | transloco }}
      </h2>
      <p class="text-paragraph-s-reg">
        {{ "calculator.BasicInfoText" | transloco }}
      </p>
    </div>
    <form class="flex flex-col items-center md:flex-row" [formGroup]="tripForm">
      <div class="flex w-full flex-col gap-8">
        <div class="flex flex-col items-start">
          <label for="title" class="text-paragraph-xs-med text-greyscale-700">
            {{ "calculator.tripName" | transloco }}
          </label>
          <input pInputText id="title" formControlName="title" [fluid]="true" />
          <app-error [control]="tripForm.get('title')!" />
        </div>

        <div class="flex w-full flex-row gap-4">
          <div class="flex flex-1 flex-col items-start">
            <label
              for="travellers"
              class="text-paragraph-xs-med text-greyscale-700"
            >
              {{ "calculator.travellersNumber" | transloco }}
            </label>
            <input
              pInputText
              id="travellers"
              formControlName="travellers"
              [fluid]="true"
            />
            <app-error [control]="tripForm.get('travellers')!" />
          </div>

          <div class="flex flex-1 flex-col items-start">
            <label for="days" class="text-paragraph-xs-med text-greyscale-700">
              {{ "calculator.tripDuration" | transloco }}
            </label>
            <p-inputNumber id="days" formControlName="days" [fluid]="true" />
            <app-error [control]="tripForm.get('days')!" />
          </div>
        </div>

        <div class="flex w-full flex-row gap-4">
          <div class="flex flex-1 flex-col items-start">
            <label for="price" class="text-paragraph-xs-med text-greyscale-700">
              {{ "calculator.label.price" | transloco }}
            </label>
            <p-inputNumber
              id="price"
              formControlName="price"
              [fluid]="true"
              [min]="0"
              [minFractionDigits]="0"
              [maxFractionDigits]="2"
              suffix=" €"
            />
          </div>

          <div class="flex flex-1 flex-col items-start">
            <label for="startDate" class="text-paragraph-xs-med text-greyscale-700">
              {{ "calculator.label.startDate" | transloco }}
            </label>
            <p-datepicker
              id="startDate"
              formControlName="startDate"
              [fluid]="true"
              [showIcon]="true"
              dateFormat="dd/mm/yy"
              appendTo="body"
            />
          </div>
        </div>

        <div class="flex w-full flex-1 flex-col items-start">
          <label for="days" class="text-paragraph-xs-med text-greyscale-700">
            {{ "calculator.destination" | transloco }}
          </label>
          <app-select-country [formGroup]="tripForm" class="w-full" />
          <app-error [control]="tripForm.get('countryCode')!" />
        </div>
        @if (packLimitationService.canFilterClient()) {
          <div class="flex w-full flex-1 flex-col items-start">
            <label for="days" class="text-paragraph-xs-med text-greyscale-700">
              {{ "calculator.label.client" | transloco }}
            </label>
            <app-company-client [formGroup]="tripForm" class="w-full" />
            <app-error [control]="tripForm.get('companyClientsId')!" />
          </div>
        } @else {
          <app-locked-button
            [label]="'calculator.label.client' | transloco"
            [limitedFeature]="limitedFeature"
            [fluid]="true"
          />
        }
      </div>
    </form>
  </div>
</div>
<div class="flex w-full items-end justify-end">
  <p-button
    [label]="'close' | transloco"
    (click)="tripCreationModalService.close()"
    severity="secondary"
    [text]="true"
  />
  <p-button
    [label]="
      (tripCreationModalService.mode() === 'create' ? 'continue' : 'save')
        | transloco
    "
    (click)="
      tripCreationModalService.mode() === 'create' ? createTrip() : editTrip()
    "
    [loading]="loading"
    [disabled]="tripForm.invalid"
  />
</div>
